import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { Button } from "./ui/button";

export function ThemeToggle({ compact = false } = {}) {
  const { theme, toggleTheme } = useTheme();
  // Compact mode = icon only. Used in the mobile header where space beside the
  // hamburger is tight; the full label variant continues to render on desktop.
  if (compact) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={toggleTheme}
        aria-label="Toggle light/dark theme"
        className="h-9 w-9 p-0"
        data-testid="theme-toggle"
      >
        {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
      </Button>
    );
  }
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleTheme}
      aria-label="Toggle light/dark theme"
      className="gap-2"
      data-testid="theme-toggle"
    >
      {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
      {theme === "dark" ? "Light" : "Dark"}
    </Button>
  );
}
